import { getLifecycle } from "service/utils"

const REDUCER_NAME = "USER_TOURNAMENT";
const ACTION_TYPE = "GET_USER_TOURNAMENT"

const UserTournamentActionType = getLifecycle(REDUCER_NAME, ACTION_TYPE);

export default UserTournamentActionType